var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconCities(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3_29)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5 40.5C26.5 41.7509 25.5297 43.2283 23.1912 44.4811C20.9155 45.7002 17.6686 46.5 14 46.5C10.3314 46.5 7.08446 45.7002 4.80884 44.4811C2.47033 43.2283 1.5 41.7509 1.5 40.5C1.5 39.2491 2.47033 37.7717 4.80884 36.5189C7.08446 35.2998 10.3314 34.5 14 34.5C17.6686 34.5 20.9155 35.2998 23.1912 36.5189C25.5297 37.7717 26.5 39.2491 26.5 40.5Z",
    stroke: "#152C5B",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5 12.4464C26.5 15.6177 25.0038 22.5551 22.5085 28.7397C21.2671 31.8162 19.821 34.5968 18.2682 36.5806C16.6698 38.6227 15.216 39.5 14 39.5C12.784 39.5 11.3302 38.6227 9.73176 36.5806C8.179 34.5968 6.73286 31.8162 5.49155 28.7397C2.99619 22.5551 1.5 15.6177 1.5 12.4464C1.5 6.56188 6.92571 1.5 14 1.5C21.0743 1.5 26.5 6.56188 26.5 12.4464Z",
    fill: "white",
    stroke: "#152C5B",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 16,
    r: 4.5,
    stroke: "#FF498B",
    strokeWidth: 3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_29"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCities);
export default __webpack_public_path__ + "static/media/icon-cities.7aa0804c59334fc1ae2f03a4526e0ae8.svg";
export { ForwardRef as ReactComponent };